import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';
import { useState } from 'react';

// Import existing types to use in function signatures
import { WebSocketConnectionResponseFromSchema } from '../schemas/websocketSchemas';

/**
 * Hook for connecting to websocket with built-in state management
 * Includes Zod validation for type safety
 */
export const useConnectWebsocket = () => {
  const { callAPI } = useAPI(); // GET

  const [data, setData] = useState<WebSocketConnectionResponseFromSchema | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  /**
   * Connect to websocket
   * @returns Promise with boolean indicating success
   */
  const action = async (): Promise<boolean> => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await callAPI(buildApiUrl('websocket/connect'), null, undefined, {
        method: 'POST',
      });

      // Validate the response data
      const validatedData =
        /* WebSocketConnectionResponseSchema.parse( */
        response /* )*/ as WebSocketConnectionResponseFromSchema;

      setData(validatedData);
      return true;
    } catch (error) {
      console.error('Error in useConnectWebsocket:', error);
      setError(error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isLoading,
    error,
    action,
  };
};
